var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.condition)?_c('span',{attrs:{"title":_vm.$gettext('condition_rating') + ' : ' + _vm.$gettext(_vm.condition, 'condition_ratings')}},[_c('icon-condition',{attrs:{"condition":_vm.condition}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }